import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { IconCheck } from '@rossum/ui/icons/tabler';
import { Button, SvgIcon } from '@rossum/ui/material';
import {
  togglePendingValidationId,
  validate,
} from '../../redux/modules/datapoints/actions';
import { pendingValidationIdsSelector } from '../../redux/modules/datapoints/selector';
import { openPopup } from '../../redux/modules/popup/actions';
import { AnyDatapointDataST } from '../../types/datapoints';
import { ButtonDatapointSchema } from '../../types/schema';
import { State } from '../../types/state';
import { AnnotationValidation } from '../../types/user';

type OwnProps = {
  inFooter: boolean;
  annotationValidationMode: AnnotationValidation | undefined;
  schema: ButtonDatapointSchema;
  data: AnyDatapointDataST;
};

type DispatchProps = {
  onClick: () => void;
};

type StateProps = {
  isPendingValidation: boolean;
};

type Props = OwnProps & DispatchProps & StateProps;

const ButtonDatapoint = ({
  isPendingValidation,
  schema: { label },
  onClick,
  inFooter,
}: Props) => (
  <Button
    variant="contained"
    data-cy="button-datapoint"
    onClick={() => onClick()}
    size={inFooter ? 'small' : 'medium'}
    sx={{ flex: 1, color: theme => theme.palette.common.white }}
    endIcon={
      isPendingValidation ? (
        <SvgIcon fontSize="small">
          <IconCheck />
        </SvgIcon>
      ) : null
    }
  >
    {label}
  </Button>
);

const mapStateToProps = (state: State, { data: { id } }: OwnProps) => {
  const pendingValidationIds = pendingValidationIdsSelector(state);

  return {
    isPendingValidation: pendingValidationIds.includes(id),
  };
};

const mapDispatchToProps = (
  dispatch: Dispatch,
  {
    schema: { popupUrl, canObtainToken },
    data: { id },
    annotationValidationMode,
  }: OwnProps
) => {
  return {
    onClick: () => {
      if (popupUrl) {
        dispatch(openPopup(popupUrl, canObtainToken === true));
        return;
      }

      if (annotationValidationMode === 'on-demand') {
        dispatch(togglePendingValidationId(id));
        return;
      }

      dispatch(validate([id], undefined, ['user_update', 'updated']));
    },
  };
};

export default connect<StateProps, DispatchProps, OwnProps, State>(
  mapStateToProps,
  mapDispatchToProps
)(ButtonDatapoint);
